module.exports = __webpack_public_path__ + "img/ditan_zc_zhaoxizi.f899de2a.jpg";